'use client'

/**
 * Providers + global PortalSelector rail (unlock path if providers.tsx is GB-locked).
 */

import React from 'react'
import { Providers } from './providers'
import { PortalSelector } from '@/shared/portals/PortalSelector'

interface ProvidersPortalProps {
  children: React.ReactNode
}

export function ProvidersPortal({ children }: ProvidersPortalProps) {
  return (
    <Providers>
      {children}
      <PortalSelector />
    </Providers>
  )
}

export default ProvidersPortal
